import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { AccountState } from 'src/app/enums/account-state.enum';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { BusinessEntityService } from 'src/app/services/business-entity.service';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddMemberComponent implements OnInit {
  /**
   * personFrom
   */
  personFrom: UntypedFormGroup;
  /**
   * addressFrom
   */
  addressFrom: UntypedFormGroup;
  /**
   * memberForm
   */
  memberForm: UntypedFormGroup;
  /**
   * The Current user
   */
  user: BusinessUserResource;
  /**
   * The Genders a Member can have
   */
  public genderOptions = [
    { value: 'MALE', viewValue: 'Herr' },
    { value: 'FEMALE', viewValue: 'Frau' },
    { value: 'UNDEFINED', viewValue: 'Divers' },
  ]
  /**
   * constructor
   * Init the Forms
   * @param fb 
   * @param businessEntityService 
   * @param overlayService 
   * @param route 
   * @param businessuserService 
   */
  constructor(
    private fb: UntypedFormBuilder,
    private businessEntityService: BusinessEntityService,
    private overlayService: OverlayService,
    private route: ActivatedRoute,
    private businessuserService: BusinessuserService) {
    this.personFrom = this.fb.group({
      gender: ['', [Validators.required]],
      birthday: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      title: ['', []],
    })

    this.addressFrom = this.fb.group({
      street: ['', [Validators.required, Validators.pattern(/^([\S\s]+?)\s+([\d-]*)\s*([\w])?$/)]],
      postcode: ['', [Validators.required, Validators.maxLength(5), Validators.minLength(5), Validators.pattern(/^[0-9]\d*$/)]],
      city: ['', [Validators.required]],
      countryCode: ['DE', []],
      location: this.fb.group({
        lat: ['', []],
        lng: ['', []],
      })
    })

    this.memberForm = this.fb.group({
      publicId: ['', []],
      clientId: ['', []],
      internalId: ['', []],
      phone:['', []],
      mobile: ['', []],
      email: ['', [Validators.required, Validators.email]],
      account: this.fb.group({
        username: ['', []],
        role: this.fb.group({
          name: ['', []],
        })
      })
    });
  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {

  }
  /**
   * Crate a new member and add it to the Company
   * @returns 
   */
  createUser() {
    this.memberForm.markAllAsTouched();
    this.personFrom.markAllAsTouched();
    this.addressFrom.markAllAsTouched();

    if (this.memberForm.invalid || this.personFrom.invalid || this.addressFrom.invalid) {
      return;
    }
    this.route.params.subscribe(val => {
      this.businessEntityService.getBusinessEntityService(val['id']).subscribe((ent: BusinessEntityResource) => {
        this.businessEntityService.createAnonMember().subscribe(anon => {
          let tempUser: BusinessUserResource = anon;
          tempUser.account.state = AccountState.ACTIVE;
          tempUser.account.username = this.memberForm.getRawValue().account.username;
          tempUser.person = this.personFrom.getRawValue();
          tempUser.address = this.addressFrom.getRawValue()
          tempUser.email = this.memberForm.getRawValue().email;
          tempUser.mobile = this.memberForm.getRawValue().phone;
          tempUser.phone = this.memberForm.getRawValue().phone;
          this.businessEntityService.updateAnonMember(tempUser).subscribe(value => {
            this.businessEntityService.addMember(ent.publicId, value).subscribe(valueFromADD => {
              this.overlayService.openSnackBar("Mitarbeier erfolgreich angelegt")
            })
          })
        })
      })
    })

  }
}